import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
    name: "set",
    standalone: false
})
export class SetPipe implements PipeTransform {
  transform(value: any[]): any {
    return new Set(value);
  }
}
